import React, { useEffect, useState } from 'react';

const CountdownTimer = ({ targetTime, message, onEnd }) => {
    const [timeRemaining, setTimeRemaining] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date().getTime();
            const target = new Date(targetTime).getTime();
            const difference = target - now;

            if (difference <= 0) {
                clearInterval(interval);
                setTimeRemaining('00:00:00');
                if (onEnd) onEnd(); // Optional callback if you want to trigger something when the countdown ends
            } else {
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / (1000 * 60)) % 60);
                const seconds = Math.floor((difference / 1000) % 60);
                setTimeRemaining(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [targetTime, onEnd]);

    return (
        <p className='text-center fs-3 text-black fw-medium mt-lg-5 text-capitalize'>
            {message}: {timeRemaining}
        </p>
    );
};


export default CountdownTimer